
import { comparisonCatalog } from '~/content/marketing/catalog'
import marketing from '~/mixins/marketing'
export default {
  mixins: [marketing],
  props: { exclude: { type: String, default: '' } },
  computed: { items () { return comparisonCatalog(this.$i18n.locale).filter(item => item.slug !== this.exclude) } }
}
